import { useAuthUser } from "../../hooks/useAuthUser";
import { RpiNotification, useRpiNotifications } from "../../hooks/useRpiNotifications";
import React from "react";
import { Alert, Button, tokens } from "@blurb/codex-react";
import { IconV3 } from "@rpi/openapi-core";
import { Body, Heading } from "../Typography";
import { RpaDrawer } from "../../rpi-core/drawer/RpaDrawer";
import { CreatePaymentMethod } from "../../views/admin/billing/PaymentMethodCreateViewV2";
import { createStyles } from "@mantine/core";

const useAlertStyles = createStyles({
  paymentAlert: {
    width: "100%",
    display: "flex",
    justifyContent: "space-between",
    gap: tokens.spacing[1],
  },
  alertContent: {
    display: "flex",
    justifyContent: "flex-start",
    gap: tokens.spacing[2],
  },
  alertText: {
    display: "flex",
    flexDirection: "column",
    gap: tokens.spacing[1],
  },
  alertTitle: {
    color: tokens.color.semantic.text.bold,
  },
  alertDescription: {
    color: tokens.color.semantic.text.subtle,
  },
  addPaymentDrawer: {
    padding: tokens.spacing[6],
    paddingTop: 0,
  },
  addPaymentButton: {
    flexShrink: 0,
    flexGrow: 0,
    alignSelf: "center",
  },
});

export const AddPaymentMethod = () => {
  const user = useAuthUser();
  const { classes } = useAlertStyles();
  const { notifications, refetch } = useRpiNotifications();
  const [drawerOpen, setDrawerOpen] = React.useState(false);

  const showPaymentNotification = React.useMemo(
    () => user.is.CUSTOMER_ADMIN && notifications[RpiNotification.PAYMENT_METHOD],
    [notifications, user]
  );

  const addPaymentMethod = React.useCallback(() => setDrawerOpen(true), []);
  const closeDrawer = React.useCallback(() => setDrawerOpen(false), []);

  if (!user.is.CUSTOMER_ADMIN || user.isSandbox || !showPaymentNotification) return null;

  return (
    <>
      <Alert type="error" size="large">
        <div className={classes.paymentAlert}>
          <div className={classes.alertContent}>
            <IconV3 size={24} color={tokens.color.semantic.icon.danger} icon="error" />
            <div className={classes.alertText}>
              <Heading className={classes.alertTitle}>Add your payment method</Heading>
              <Body size="sm" className={classes.alertDescription}>
                You need to provide a payment method to set up the API integration. Orders will not process correctly
                until this is added.
              </Body>
            </div>
          </div>
          <Button className={classes.addPaymentButton} size="small" onClick={addPaymentMethod}>
            Add Payment Method
          </Button>
        </div>
      </Alert>
      <RpaDrawer title="Add payment method" opened={drawerOpen} onClose={closeDrawer}>
        <div className={classes.addPaymentDrawer}>
          <CreatePaymentMethod
            onComplete={() => {
              closeDrawer();
              refetch(RpiNotification.PAYMENT_METHOD);
            }}
            onCancel={closeDrawer}
          />
        </div>
      </RpaDrawer>
    </>
  );
};
